(function(module) {
    'use strict';

    function VerifyEmailConfig($stateProvider, $translatePartialLoaderProvider) {
        $stateProvider
            .state('verify-email', {
                url: '/verify-email/:uid/:token/:redirect',
                data: {
                    pageTitle: 'VERIFY_EMAIL.PAGE_TITLE',
                },
                views: {
                    'main@': {
                        templateUrl: '/js/components/layouts/content-only.html',
                        controller: 'MainController as $ctrl',
                    },
                    'content@verify-email': {
                        templateUrl: '/js/authentication/verify-email/verify-email.html',
                        controller: 'VerifyEmailCtrl as $ctrl',
                    },
                },
                params: {
                    uid: { squash: true, value: null },
                    token: { squash: true, value: null },
                    redirect: { squash: true, value: null },
                },
                resolve: {
                    token: (User, LoopBackAuth, $state, $stateParams) => {
                        if ($stateParams.uid && $stateParams.token) {
                            User
                                .confirm({
                                    uid: $stateParams.uid,
                                    token: $stateParams.token,
                                })
                                .$promise
                                .then((accessToken) => {

                                    console.log('accessToken', accessToken);
                                    const { id, userId, user } = accessToken;

                                    // login in the user & move on to the account creation
                                    LoopBackAuth.setUser(accessToken.id, accessToken.userId, accessToken.user);
                                    LoopBackAuth.rememberMe = true;
                                    LoopBackAuth.save();

                                    $state.go($stateParams.redirect);
                                })
                                .catch((error) => {
                                    console.log('error', error);
                                    $state.go('login');
                                });
                        }
                    },
                },
                bodyClass: 'page--verify-email',
            });
        $translatePartialLoaderProvider.addPart('/js/authentication/verify-email');
    }

    function VerifyEmailCtrl(Store, LoopBackAuth, $state) {
        this.clearCookies = () => {
            Store.setCurrentSubAccountId(null);

            LoopBackAuth.clearUser();
            LoopBackAuth.clearStorage();
            $state.go('login');
        };
    }

    module
        .config(VerifyEmailConfig)
        .controller('VerifyEmailCtrl', VerifyEmailCtrl);

})(angular.module('rocket.components'));
